/* ========== Simple reveal on scroll ========== */
(() => {
  const obs = new IntersectionObserver((ents)=>{
    ents.forEach(e=>{
      if(e.isIntersecting){ e.target.classList.add('is-in'); obs.unobserve(e.target); }
    });
  }, {threshold:.18});
  document.querySelectorAll('[data-reveal]').forEach(el=>obs.observe(el));
})();

/* ========== Config de imágenes por color y manga (visuales) ========== */
const IMG_MAP = {
  short: {
    camo:  'https://cdn.shopify.com/s/files/1/0602/9701/9597/files/Strike_Ops_Camo_T-Shirt_Front.png?v=1761325951',
    white: 'https://cdn.shopify.com/s/files/1/0602/9701/9597/files/Strike_Ops_White_T-Shirt_Front.png?v=1761325950',
    black: 'https://cdn.shopify.com/s/files/1/0602/9701/9597/files/Strike_Ops_Black_T-Shirt_Front.png?v=1761325951',
    green: 'https://cdn.shopify.com/s/files/1/0602/9701/9597/files/Strike_Ops_Green_T-Shirt_Front.png?v=1761325951',
    wine:  'https://cdn.shopify.com/s/files/1/0602/9701/9597/files/Strike_Ops_Red_T-Shirt_Front.png?v=1761325951'
  },
  long: {
    camo:  'https://cdn.shopify.com/s/files/1/0602/9701/9597/files/Strike-Ops_Camo_long-sleeved_Front.png?v=1761326134',
    white: 'https://cdn.shopify.com/s/files/1/0602/9701/9597/files/Strike-Ops_White_long-sleeved_Front.png?v=1761326143',
    black: 'https://cdn.shopify.com/s/files/1/0602/9701/9597/files/Strike-Ops_Black_long-sleeved_Front.png?v=1761326146',
    green: 'https://cdn.shopify.com/s/files/1/0602/9701/9597/files/Strike-Ops_Green_long-sleeved_Front.png?v=1761326151',
    wine:  'https://cdn.shopify.com/s/files/1/0602/9701/9597/files/Strike-Ops_Red_long-sleeved_Front.png?v=1761326152'
  },
  tank: {
    camo:  'https://cdn.shopify.com/s/files/1/0602/9701/9597/files/Strike_Ops_TankTop_Camo_Front.png?v=1761326788',
    white: 'https://cdn.shopify.com/s/files/1/0602/9701/9597/files/Strike_Ops_TankTop_White_Front.png?v=1761326791',
    black: 'https://cdn.shopify.com/s/files/1/0602/9701/9597/files/Strike_Ops_TankTop_Black_Front.png?v=1761326793',
    green: 'https://cdn.shopify.com/s/files/1/0602/9701/9597/files/Strike_Ops_TankTop_Green_Front.png?v=1761326796',
    wine:  'https://cdn.shopify.com/s/files/1/0602/9701/9597/files/Strike_Ops_TankTop_Red_Front.png?v=1761326798'
  }
};

/* ========== Mapeo de handles para pedir el JSON del producto ========== */
/* Colores en UI -> slug en URL */
const COLOR_TO_SLUG = {
  camo:  'ghost',
  white: 'white',
  black: 'black',
  green: 'dark-green',
  wine:  'burgundy'
};
/* Tipo de manga en UI -> parte del handle */
const SLEEVE_TO_SLUG = {
  short: 'short',
  long:  'long',
  tank:  'tank'
};
/* Construye el handle final: strike-ops-compression-<sleeve>-sleeve-<color> */
function productHandleFor(sleeve, color){
  const s = SLEEVE_TO_SLUG[sleeve];
  const c = COLOR_TO_SLUG[color];
  return `strike-ops-compression-${s}-sleeve-${c}`;
}

/* ========== Estado actual ========== */
let currentSleeve = 'short';
let currentColor  = 'camo';
let selectedVariantId = null;        // se setea al elegir talla
let currentProduct = null;           // último product.json cargado

/* DOM refs */
const $img       = document.getElementById('hero-img');
const $buyThumb  = document.getElementById('buy-thumb');
const $buyLink   = document.getElementById('buy-link');   // botón sticky
const $buyVar    = document.getElementById('buy-variant');
const $primary   = document.getElementById('primary-cta'); // botón principal
const $sizesWrap = document.getElementById('size-picker');
const $price     = document.getElementById('price');
const $buyPrice  = document.getElementById('buy-price');
const $toast     = document.getElementById('jl-toast');

/* ========== Helpers UI ========== */
function setActive(el, groupSelector){
  document.querySelectorAll(groupSelector).forEach(b=>b.classList.remove('is-active'));
  el.classList.add('is-active');
}
function capitalize(s){ return (s||'').charAt(0).toUpperCase()+s.slice(1); }
function money(cents){
  try { return new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format((+cents)/100); }
  catch(_){ return `$${(+cents/100).toFixed(2)} MXN`; }
}
function toast(msg='Se agregó al carrito'){
  if(!$toast) return;
  $toast.textContent = msg;
  $toast.classList.add('is-on');
  clearTimeout($toast._t);
  $toast._t = setTimeout(()=> $toast.classList.remove('is-on'), 2200);
}

/* Pinta imagen + texto del sticky */
function paintVisual(){
  const src = IMG_MAP[currentSleeve]?.[currentColor];
  if(src){ $img.src = src; if($buyThumb) $buyThumb.src = src; }
  const colorName  = {camo:'Ghost', white:'Blanco', black:'Negro', green:'Verde', wine:'Vino'}[currentColor] || capitalize(currentColor);
  const sleeveName = currentSleeve === 'short' ? 'Manga corta' : currentSleeve === 'long' ? 'Manga larga' : 'Sin mangas';
  if($buyVar) $buyVar.textContent = `${sleeveName} · ${colorName}`;
}

/* Pinta precio (variant o fallback producto) */
function paintPriceFrom(variant, product){
  const cents = variant?.price ?? product?.price ?? product?.price_min ?? null;
  if(cents == null) return;
  if($price)    $price.textContent    = money(cents);
  if($buyPrice) $buyPrice.textContent = money(cents);
}

/* ========== Tallas dinámicas por producto: precio independiente de la talla ========== */
async function paintSizes(){
  selectedVariantId = null;
  const handle = productHandleFor(currentSleeve, currentColor);
  try{
    const res = await fetch(`/products/${handle}.js`, {credentials:'same-origin'});
    if(!res.ok) throw new Error('No se pudo cargar el producto');
    const p = await res.json();
    currentProduct = p;

    // 👉 Precio que mostraremos SIEMPRE para esta combinación (independiente de talla)
    // Usa price (Shopify) o cae a price_min o primer variant.
    const baseCents =
      (p.price != null ? p.price : (p.price_min != null ? p.price_min : (p.variants?.[0]?.price ?? null)));
    if(baseCents != null){
      if($price)    $price.textContent    = money(baseCents);
      if($buyPrice) $buyPrice.textContent = money(baseCents);
    }

    // Render de tallas
    const order = ['XS','S','M','L','XL','2XL','XXL','3XL'];
    const bySize = {};
    p.variants.forEach(v => { bySize[v.option1] = v; });

    $sizesWrap.innerHTML = '';
    const btnMap = {};

    order.filter(size => bySize[size]).forEach((size) => {
      const v = bySize[size];
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'chip size-chip' + (v.available ? '' : ' is-disabled');
      btn.textContent = size;
      btn.disabled = !v.available;
      btn.dataset.variantId = v.id;

      btn.addEventListener('click', () => {
        if(btn.disabled) return;
        selectedVariantId = v.id;
        document.querySelectorAll('.size-chip').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        // ❌ Ya NO cambiamos el precio aquí; se mantiene el del producto.
        // paintPriceFrom(v, currentProduct);  <-- elimina/omite esta línea
      });

      $sizesWrap.appendChild(btn);
      btnMap[size] = btn;
    });

    // Autoselección de la primera disponible (solo para poder agregar al carrito)
    const firstAvailable = p.variants.find(x => x.available) || p.variants[0];
    if(firstAvailable){
      selectedVariantId = firstAvailable.id;
      const btn = btnMap[firstAvailable.option1];
      if(btn) btn.classList.add('is-active');

      // ❌ Ya NO sobreescribimos el precio aquí
      // paintPriceFrom(firstAvailable, p);   <-- elimina/omite esta línea
    }else{
      $sizesWrap.innerHTML = '<div class="size-empty">Sin tallas disponibles</div>';
    }
  }catch(err){
    console.warn(err);
    $sizesWrap.innerHTML = '<div class="size-empty">No disponible</div>';
  }
}

/* ========== Add to cart ========== */
async function addToCart(){
  // Si no hay talla seleccionada, intenta elegir la primera disponible
  if(!selectedVariantId){
    const first = document.querySelector('.size-chip:not(.is-disabled)');
    if(first){ first.click(); }
  }
  if(!selectedVariantId){
    toast('Selecciona una talla');
    return;
  }

  try{
    const res = await fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
    });
    if(!res.ok) throw new Error('No se pudo agregar al carrito');

    await res.json();
    // Notifica/actualiza drawer si el tema lo tiene
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    const drawer = document.querySelector('cart-drawer, cart-notification');
    if(drawer && typeof drawer.open === 'function'){ drawer.open(); }
    toast('Se agregó al carrito');
  }catch(err){
    console.error(err);
    toast('Hubo un problema. Intenta de nuevo');
  }
}

/* ========== Eventos ========== */
document.querySelectorAll('.swatch .dot').forEach(btn=>{
  btn.addEventListener('click', async ()=>{
    currentColor = btn.dataset.color;
    setActive(btn, '.swatch .dot');
    paintVisual();
    await paintSizes();               // <- carga producto y pinta precio
  });
});
document.querySelectorAll('.sleeves .chip').forEach(btn=>{
  btn.addEventListener('click', async ()=>{
    currentSleeve = btn.dataset.sleeve;
    setActive(btn, '.sleeves .chip');
    paintVisual();
    await paintSizes();               // <- carga producto y pinta precio
  });
});
$primary?.addEventListener('click', addToCart);
$buyLink?.addEventListener('click', addToCart);

/* ========== Primera pinta ========== */
paintVisual();
paintSizes();

/* ========== Parallax sutil ========== */
(() => {
  const els = document.querySelectorAll('.parallax,[data-speed]');
  if(!els.length) return;
  window.addEventListener('scroll', ()=>{
    const y = window.scrollY;
    els.forEach(el=>{
      const speed = parseFloat(el.dataset.speed || '0.12');
      el.style.transform = `translateY(${y * speed * 0.2}px)`;
    });
  }, {passive:true});
})();

// ==== Fix de franja blanca bajo el header oculto ====
(() => {
  const header =
    document.querySelector('sticky-header') ||
    document.querySelector('#shopify-section-header') ||
    document.querySelector('.shopify-section-header-sticky') ||
    document.querySelector('.header-wrapper') ||
    document.querySelector('header.header');

  // posibles placeholders
  let placeholder =
    document.querySelector('.header__placeholder, .shopify-section-header__placeholder') ||
    (header && header.nextElementSibling && /height/i.test(header.nextElementSibling.getAttribute('style')||'') ? header.nextElementSibling : null);

  if (!placeholder) return;

  // pinta fondo negro siempre
  const paint = () => {
    placeholder.style.background = '#0a0a0a';
  };

  // colapsa cuando el header se oculta (varios nombres posibles)
  const collapseIfHidden = () => {
    const hidden = header && (
      header.classList.contains('header-wrapper--hidden') ||
      header.classList.contains('header--hidden') ||
      header.classList.contains('shopify-section-header-hidden') ||
      header.classList.contains('is-hidden')
    );
    if (hidden) {
      // algunos temas crean un DIV con height inline; le ponemos clase para que el CSS lo colapse
      placeholder.classList.add('jl-collapsed');
      placeholder.style.height = '0px';
      placeholder.style.minHeight = '0px';
      placeholder.style.overflow = 'hidden';
    } else {
      placeholder.classList.remove('jl-collapsed');
      // mantenemos el fondo negro aunque recupere altura
      paint();
    }
  };

  paint();
  collapseIfHidden();

  // Observa cambios de clase del header
  const mo = new MutationObserver(collapseIfHidden);
  if (header) mo.observe(header, { attributes:true, attributeFilter:['class'] });

  // fallback por scroll / resize
  window.addEventListener('scroll', collapseIfHidden, {passive:true});
  window.addEventListener('resize', collapseIfHidden);
})();

